import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-recover',
  imports: [TranslatePipe],
  templateUrl: './recover.html',
  styleUrl: './recover.scss'
})
export class Recover implements OnInit {
  link_now: string = '';
  
  ngOnInit(): void {
    this.link_now =  environment.linkCabinetRegistration;
  }

}
